export default __webpack_public_path__ + "static/media/product1.956436ce.jpg";